const ContactType = Object.freeze({
  MINIMAL: 'minimal',
  BASIC: 'basic',
  FAMILY: 'family',
  MARITAL_STATUS: 'marital_status',
  GENERAL_CONTACT: 'general_contact'
})

export default ContactType
